import React, { Fragment } from 'react';
import { Row, Col } from 'antd';
import ContainerBody from '@components/ContainerBody';
import Breadcrumb from '@components/Breadcrumb';
import { Add } from './components/Add';

const AddDevice = () => {
  return (
    <ContainerBody>
      <div className="breadcrumb">
        <Breadcrumb
          homePath={'/dashboard'}
          routeSegments={[
            { name: 'Quản lý thiết bị', path: '/devices' },
            { name: 'Thêm mới thiết bị', path: '/devices/add' }
          ]}
        />
      </div>
      <Row>
        <Col span={24}>
          <Add />
        </Col>
      </Row>
    </ContainerBody>
  );
};

export default AddDevice;
